import { render, staticRenderFns } from "./DocumentEmbed.vue?vue&type=template&id=b5881b08"
import script from "./DocumentEmbed.vue?vue&type=script&lang=js"
export * from "./DocumentEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports